import { ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { InternshipLineItem } from './InternshipLineItem';

const { BACKRS_ASSESSMENT, SECTION_TITLES, notAvailable } = appStrings.modules.nugget.internship;

export function BackrsAssessment(): ReactElement {
  // once the data is available, we will replace the notAvailable with the actual values via internshipInfo
  const valueMap: Record<string, string> = {
    [BACKRS_ASSESSMENT.growthPotential]: notAvailable,
    [BACKRS_ASSESSMENT.compensation]: notAvailable,
    [BACKRS_ASSESSMENT.intensity]: notAvailable,
    [BACKRS_ASSESSMENT.gpaRequirement]: notAvailable,
    [BACKRS_ASSESSMENT.achievementRequirement]: notAvailable,
    [BACKRS_ASSESSMENT.experienceRequirement]: notAvailable,
    [BACKRS_ASSESSMENT.technicalSkills]: notAvailable,
  };

  return (
    <Box>
      <Typography variant="body1" sx={sectionTitleStyle}>
        {SECTION_TITLES.backrsAssessment}
      </Typography>

      {Object.entries(valueMap).map(([title, value]) => (
        <InternshipLineItem key={title} title={title} value={value} />
      ))}
    </Box>
  );
}

const sectionTitleStyle: SxProps<Theme> = {
  fontWeight: 700,
  color: appColors.color.blue1,
  mb: 1,
};
